
import React from 'react';
import { FileUploadSection } from './product-upload/FileUploadSection';
import { FilePreview } from './product-upload/FilePreview';
import { ProductPreview } from './product-upload/ProductPreview';
import { ProcessingIndicator } from './product-upload/ProcessingIndicator';
import { EmptyState } from './product-upload/EmptyState';
import { useProductUpload } from './product-upload/useProductUpload';

interface ProductUploadProps {
  onUploadComplete: () => void;
}

const ProductUpload = ({ onUploadComplete }: ProductUploadProps) => {
  const {
    file,
    previewData,
    isProcessing,
    parseErrors,
    fileInputRef,
    bulkCreateProducts,
    handleFileChange,
    handleUpload,
    handleReset,
    downloadTemplate,
    downloadTestFile,
  } = useProductUpload(onUploadComplete);

  const showEmptyState = !file && !isProcessing && previewData.length === 0 && parseErrors.length === 0;

  return (
    <div className="space-y-6">
      <FileUploadSection 
        isProcessing={isProcessing}
        onFileChange={handleFileChange}
        onDownloadTemplate={downloadTemplate}
        onDownloadTestFile={downloadTestFile}
      />

      {file && <FilePreview file={file} />}
      
      <ProcessingIndicator isProcessing={isProcessing} />
      
      <ProductPreview 
        products={previewData}
        isPending={bulkCreateProducts.isPending}
        onUpload={handleUpload}
        onReset={handleReset}
        parseErrors={parseErrors}
      />

      {showEmptyState && (
        <EmptyState 
          onSelectFile={() => fileInputRef.current?.click()} 
          onDownloadTemplate={downloadTemplate}
        />
      )}
    </div>
  );
};

export default ProductUpload;
